import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import { selectSchedule } from "../../../redux/actions";
// HOOKS
import { usePlayeurInscription } from "../../../hooks/usePlayeurInscription";
// COMPONENTS
import ConfirmationModal from "../Schedules/confirmationModal/ConfirmationModal";
import RefusePriority from "./RefusePriority";

export default function PriorityInscription() {
  const navigate = useNavigate();
  const { name, birthDay, email, phone } = useSelector((state) => state.user);
  const playeurInscription = usePlayeurInscription(name);
  const [schedulesRegisted, setSchedulesRegisted] = useState([]);

  useEffect(() => {
    if (Object.keys(playeurInscription).length > 0) {
      const selectedSchedules = Object.values(playeurInscription)
        .filter((schedule) => schedule && Object.keys(schedule).length > 0)
        .map(
          (schedule) =>
            `${schedule.day} de ${schedule.startHour} à ${schedule.endHour}`
        );

      setSchedulesRegisted(selectedSchedules);
    }
  }, [playeurInscription]);
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);

  const handleAccept = () => {
    dispatch(selectSchedule(playeurInscription[0], "First"));
    setOpenModal(true);
  };
  const dataPlayeur = {
    name: name,
    birthDay: birthDay.slice(0, 4),
    email: email,
    phone: phone,
  };
  return (
    <div className="priority-inscription-container">
      <div className="card">
        {schedulesRegisted.length > 0 ? (
          schedulesRegisted.map((schedule, index) => (
            <>
              <h1
                className="title"
                style={{ color: "var(--background-color)", margin: "10px 0" }}
              >
                Bonne nouvelle ! <br /> Vous êtes prioritaire sur le créneau du
                :
              </h1>
              <h2 style={{ fontWeight: "bold" }} key={index}>
                {schedule}
              </h2>
              <p>
                Vous avez la possibilité d'accepter ou de refuser ce créneau qui
                vous était attribué l'année précédente. En cas de refus, votre
                inscription à un autre créneau ne sera possible qu'à partir du
                16 juin à 9h.
              </p>
            </>
          ))
        ) : (
          <h2 style={{ fontWeight: "bold", fontSize: "20px" }}>
            Aucun créneau trouvé (vous avez changé de niveau).
          </h2>
        )}

        {schedulesRegisted.length !== 0 ? (
          <div className="buttons">
            <button
              className="cancel-button"
              onClick={() => setOpenModal2(true)}
            >
              Refuser
            </button>
            <button className="confirm-button" onClick={handleAccept}>
              Accepter
            </button>
          </div>
        ) : (
          <div className="buttons">
            <button
              className="confirm-button"
              onClick={() => navigate("/emettre-un-souhait")}
            >
              Emmetre un souhait
            </button>
          </div>
        )}
      </div>
      {openModal && (
        <ConfirmationModal setOpenModal={setOpenModal} isPriority={true} dataPlayeur={dataPlayeur}/>
      )}
      {openModal2 && (
        <RefusePriority
          setOpenModal2={setOpenModal2}
          dataPlayeur={dataPlayeur}
          uidSchedule={playeurInscription[0].uid}
        />
      )}
    </div>
  );
}
